<template>
  <div class="title-arrow-container"
       @mouseleave="focusFalse"
       @mouseenter="focusTrue"
       :class="{'not-active-arrow' : isNotActiveArrow && !focusParam}">
    <main-title :class="[`orange-title`]">
      {{ mainTitle }}
    </main-title>
    <icon-default :icon="`arrow-orange`"/>
  </div>
</template>

<script>
import IconDefault from "@/components/shared/IconDefault.vue";
import MainTitle from "@/components/shared/text/MainTitle.vue";

export default {
  name: "OrangeTitleArrow",
  components: {MainTitle, IconDefault},
  props: {
    isNotActiveArrow: {
      type: Boolean
    },
    mainTitle: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      focusParam: false
    }
  }
}
</script>

<style scoped lang="scss">
.title-arrow-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  .icon-container {
    overflow: hidden;
    transition: all .3s ease;
  }

  .text-content {
    transition: all .3s ease;
  }
  &.not-active-arrow {
    .icon-container {
      opacity: 0;
      min-width: 0;
      width: 0;
    }
    .text-content {
      color: var(--color-purple-grey) !important;
      font-weight: 400;
    }
  }
}
@media (max-width: 3024px){
  .title-arrow-container {
    padding: 12px 0;
    column-gap: 16px;

    .icon-container {
      --size-icon: 24px;
    }
  }
}

@media (max-width: 1920px) {
  .title-arrow-container {
    padding: 7.5px 0;
    column-gap: 16px;

    .icon-container {
      --size-icon: 24px;
    }
  }
}
@media (max-width: 1600px) {
  .title-arrow-container {
    padding: 8px 0;
    column-gap: 12px;

    .icon-container {
      --size-icon: 20px;
    }
  }
}
@media (max-height: 800px) {
  .title-arrow-container {
    padding: 6px 0;
    column-gap: 12px;

    .icon-container {
      --size-icon: 16px;
    }
  }
}

@media (max-width: 1400px) and (min-height: 801px) {
  .title-arrow-container {
    padding: 8px 0;
    column-gap: 12px;

    .icon-container {
      --size-icon: 20px;
    }
  }
}

@media (max-width: 1133px) {
  .title-arrow-container {
    padding: 6px 0;
    column-gap: 12px;

    .icon-container {
      --size-icon: 16px;
    }
  }
}
@media (max-width: 769px) {
  //iPhone 14
}

@media (max-width: 769px)  and (min-height: 720px) and (max-height: 1000px) {
  //iPhone Plus
}
@media (min-height: 600px) and (max-height: 630px){
  //для экранов 8 плюс
}

@media (max-width: 375px){
  //iPhone 8
}


@media (max-width: 375px) and (min-height: 630px) {
  //iPhone X
}


@media (max-width: 320px) {
  //iPhone SE
}

@media (min-width: 3025px) {
  .title-arrow-container {
    padding: 20px 0;
    column-gap: 16px;

    .icon-container {
      --size-icon: 52px;
    }
  }
}


</style>